import { AdvancedMarker } from '@vis.gl/react-google-maps'
import type { LatLng } from '@/types/structs'

/* MarkerId("destination"): getDestinationIcon(userName) — a canvas-drawn
 * pink heart (66x60 path) above a white pill with a pink border holding the
 * name — rasterized and rendered at HEIGHT 40, anchor (0.5, 0.5).
 *
 * Rebuilt as DOM/SVG (crisp at any DPR). Proportions from the canvas code
 * at design scale (scaleCoef aside): heart 66x60; spacing 3; pill = text 30
 * w700 #FF77B7 + padding 12 vert / 36 horiz + border 3, radius 270. Total
 * height 126 design units -> 40 real px => x0.317: heart ~19px, text ~9.5px,
 * pill border ~1px, padding ~4/11px. The canvas text had NO fontFamily ->
 * browser default sans-serif; we keep that (not Poppins).
 *
 * Anchor (0.5,0.5): translateY(50%) from the bottom-centre default. */

const HEART_PATH =
  'M33 60 C 20 47, 0 32, 0 18 C 0 6, 9 0, 18 0 C 25 0, 30 4, 33 9 C 36 4, 41 0, 48 0 C 57 0, 66 6, 66 18 C 66 32, 46 47, 33 60 Z'

export function DestinationMarker({
  position,
  userName,
}: {
  position: LatLng
  userName: string
}) {
  return (
    <AdvancedMarker position={position} zIndex={3}>
      <div
        data-marker="destination"
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          height: 40,
          transform: 'translateY(50%)',
        }}
      >
        <svg width="21" height="19" viewBox="0 0 66 60" style={{ display: 'block' }}>
          <path d={HEART_PATH} fill="var(--primary)" />
        </svg>
        <div
          style={{
            marginTop: 1,
            background: '#ffffff',
            border: '1px solid var(--primary)',
            borderRadius: 999,
            padding: '3px 11px',
            fontFamily: 'sans-serif',
            fontWeight: 700,
            fontSize: 9.5,
            lineHeight: 1,
            color: 'var(--primary)',
            whiteSpace: 'nowrap',
          }}
        >
          {userName}
        </div>
      </div>
    </AdvancedMarker>
  )
}
